import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './i18n'
import axios from 'axios';
import VueAxios from 'vue-axios'
import './css/nprogress.css'
import NProgress from 'nprogress';
import VueTagsInput from '@johmun/vue-tags-input/dist/vue-tags-input'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.component('vue-tags-input', VueTagsInput);

router.beforeResolve((to, from, next) => {
  if (to.path) {
    NProgress.start();
  }
  next();
})

router.afterEach(() => {
  NProgress.done()
})
router.beforeEach((to, from, next) => {
  let language = to.params.lang;

  if (!language) {
    language = process.env.VUE_APP_I18N_LOCALE;
  }

  i18n.locale = language;

  next();
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
